@if (
  {
    users: users$ | async
  };
  as state
) {
  <users-header (searchValueChange)="searchValue$.next($event)" />
  <users-table [searchValue$]="searchValue$" [users]="state.users" />
} @else {
  <div class="oph-loading-container">
    <oph-loading />
  </div>
}
